import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string } from 'prop-types'

import threeDIcon from 'images/discover/datasets/3d.svg'
import cadEngineeringImage from 'images/discover/datasets/cad-engineering.avif'
import categoryIcon from 'images/discover/datasets/category.svg'
import cubeIcon from 'images/discover/datasets/cube-ic.svg'
import cubeSearchIcon from 'images/discover/datasets/cube-search.svg'
import customOnDemandImage from 'images/discover/datasets/custom-on-demand.avif'
import fileIcon from 'images/discover/datasets/file.svg'
import lifestyleScenesImage from 'images/discover/datasets/lifestyle-scenes.avif'
import paletteIcon from 'images/discover/datasets/palette-ic.svg'
import preMadeCollectionsImage from 'images/discover/datasets/pre-made-collections.avif'
import projectIcon from 'images/discover/datasets/project.svg'
import roboticsSimulationImage from 'images/discover/datasets/robotics-simulation.avif'
import scaleIcon from 'images/discover/datasets/scale.svg'
import shieldTickIcon from 'images/discover/datasets/shield-tick-sm.svg'

import { FORM_ANCHOR_HREF } from '../../constants'
import Label from '../Label/Label'
import Card from './Components/Card/Card'

const SMALL_IMAGE = { width: 592, height: 376 }
const WIDE_IMAGE = { width: 960, height: 400 }

const CATEGORY = { src: categoryIcon, height: 24 }
const CUBE = { src: cubeIcon, height: 16 }
const FILE = { src: fileIcon, height: 24 }
const PALETTE = { src: paletteIcon, height: 16 }
const PROJECT = { src: projectIcon, height: 24 }
const SCALE = { src: scaleIcon, height: 24 }
const SHIELD_TICK = { src: shieldTickIcon, height: 16 }
const THREE_D = { src: threeDIcon, height: 24 }

const CARD_MEDIA = [
  { image: { src: preMadeCollectionsImage, ...SMALL_IMAGE }, chipIcons: [CATEGORY, FILE, CUBE] },
  { image: { src: lifestyleScenesImage, ...SMALL_IMAGE }, chipIcons: [THREE_D, PALETTE] },
  { image: { src: roboticsSimulationImage, ...SMALL_IMAGE }, chipIcons: [THREE_D, FILE, CUBE] },
  { image: { src: cadEngineeringImage, ...WIDE_IMAGE }, chipIcons: [FILE, SCALE], isWide: true },
  { image: { src: customOnDemandImage, ...WIDE_IMAGE }, chipIcons: [PROJECT, SHIELD_TICK], isWide: true },
]

function Explore({ explore }) {
  return (
    <section className="datasets-explore">
      <div className="discover-container">
        <div className="datasets-explore__header">
          <Label icon={cubeSearchIcon} text={explore.label} />
          <h2 className="datasets-explore__title discover-heading cgt-heading-500">{explore.title}</h2>
          <p className="datasets-explore__lead cgt-body-lg">{explore.lead}</p>
        </div>
        <ul className="datasets-explore__list">
          {explore.items.map((item, index) => (
            <Card key={item.title} item={item} {...CARD_MEDIA[index]} />
          ))}
        </ul>
        <div className="datasets-explore__action">
          <Button type="primary" size="large" href={FORM_ANCHOR_HREF}>
            {explore.cta}
          </Button>
        </div>
      </div>
    </section>
  )
}

Explore.propTypes = {
  explore: shape({
    label: string.isRequired,
    title: string.isRequired,
    lead: string.isRequired,
    cta: string.isRequired,
    items: arrayOf(shape({ title: string.isRequired })).isRequired,
  }).isRequired,
}

export default Explore
